import { Link } from "react-router-dom";

// The Rating 3.0 explainer — the page every R3 tooltip and the launch post point at.
// Deliberately hardcoded Danish in the same idiom as FantasyGuidePage: this is a written
// article, not a UI surface, and running it through i18n would invite a half-translated
// version of a text whose whole point is the exact wording.
//
// Kept deliberately short. The corpus sizes, label counts and per-slice MAEs live in
// tasks/ for anyone who asks — on this page they crowded out the one number that matters.
//
// 0,0393 is the research champion's OLD-89 MAE (the deployed head measured ~0,0401-0,0412 on
// the same slice). Do not round it further: readers can cross-check against HLTV, and the
// honesty is the whole argument.

const Rating3Page = () => {
    return (
        <div className="container text-white" style={{ maxWidth: 900, paddingTop: 24, paddingBottom: 48 }}>
            <h1 className="mb-2">Rating 3.0</h1>
            <p style={{ color: "rgba(255,255,255,0.6)" }}>
                PowerStats er den første side der kan sige den har en stabil Rating 3.0. HLTV udgav
                den, men aldrig formlen, og der findes ikke ét offentligt dokument der beskriver
                hvordan den regnes ud. Så jeg regnede den ud selv.
            </p>

            <div
                className="text-center"
                style={{
                    border: "1px solid rgba(255,102,0,0.3)",
                    background: "rgba(255,102,0,0.08)",
                    borderRadius: 12,
                    padding: "1.75rem 1rem",
                    margin: "1.5rem 0",
                }}
            >
                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.95rem" }}>
                    Seks måneders arbejde, hundredvis af timer og over 1 TB demoer senere:
                </div>
                <div
                    style={{
                        fontSize: "3.25rem",
                        fontWeight: 800,
                        lineHeight: 1.1,
                        color: "#ff9933",
                        margin: "0.3rem 0",
                    }}
                >
                    0,0393
                </div>
                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.95rem" }}>
                    gennemsnitlig afvigelse fra HLTV's egen rating
                </div>
            </div>

            <p style={{ color: "rgba(255,255,255,0.6)" }}>
                Jeg trænede en model på pro-kampe hvor HLTV's officielle rating var kendt, og fik den
                til at ramme de tal ud fra demo-data alene. Ingen er kommet tættere på HLTV's officielle
                tal.
            </p>
            <p style={{ color: "rgba(255,255,255,0.6)" }}>
                Den kører på alle kampe fra sæson 32 og frem, så du kan gå tilbage og se sidste
                sæson og følge den her. Fra Ligaen til 4. division.
            </p>

            <h3 className="mt-4">📊 Hvad du kan se på siden</h3>
            <ul>
                <li>
                    <strong>Rating 3.0</strong> på hver spiller i hver kamp.
                </li>
                <li>
                    <strong>Eco-justeret</strong> — en knap på kampsiden regner tallene om efter hvad
                    modstanderen havde råd til, så en runde mod fulde køb ikke tæller som en mod
                    pistoler.
                </li>
                <li>
                    <strong>Swing</strong> — hvor meget hver spiller flyttede sandsynligheden for at vinde
                    runden. Plus er godt, minus er skidt.
                </li>
                <li>
                    Kampe uden 3.0-data falder tilbage til <strong>Rating 2.1 / 2.0</strong>, så
                    historikken ikke får huller.
                </li>
            </ul>

            <h3 className="mt-4">🤝 Én ting værd at vide</h3>
            <p style={{ color: "rgba(255,255,255,0.6)" }}>
                Modellen er trænet på pro-kampe, så på amatørniveau ligger gennemsnittet lidt højere end
                1,00. Det siger jeg hellere selv end at lade jer opdage det.
            </p>

            <div className="mt-4 d-flex flex-wrap gap-2">
                <Link to="/statsview-rating30" className="btn btn-outline-light btn-sm">
                    Se ligaens Rating 3.0-liste
                </Link>
                <Link to="/fantasy/guide" className="btn btn-outline-light btn-sm">
                    Fantasy-guide
                </Link>
                <Link to="/" className="btn btn-outline-light btn-sm">
                    ← Til forsiden
                </Link>
            </div>
        </div>
    );
};

export default Rating3Page;
